import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'wholeSalesAndStockList': [],
};

export const dailyVehiclesSalesAndStockWholesale = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DAILY_VEHICLES_WHOLESALES_SUMMARY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DAILY_VEHICLES_WHOLESALES_SUMMARY]: (state, action) => ({
      ...state,
      'loading': false,
      'wholeSalesAndStockList': action.response.data,
    }),
    [ActionTypes.FETCHED_DAILY_VEHICLES_WHOLESALES_SUMMARY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'wholeSalesAndStockList': [],
    }),
  })(state, action);
};
